import CustomButton from "../../../../components/CustomButton";
import { useDispatch, useSelector } from 'react-redux'
import { tryAddOrUpdatePageTab } from '../../../../redux/slices/dynamicUiSlice'

const PageTabSubmitButton = () => {


  const selected = useSelector((state) => state.dynamicUi.pages.tabs.selected);
  const editTab = useSelector((state) => state.dynamicUi.pages.tabs.edit);

  const isLoading = useSelector((state) => state.dynamicElements.editing.loading);

  const dispatch = useDispatch();

  const selectedTab = editTab[selected];


  const selectedGroup = useSelector((state) => (state.dynamicUi.pages.selectedGroup))
  const pageData = useSelector((state) => (state.dynamicUi.pages[selectedGroup].data))
  const selectedPage = useSelector((state) => (state.dynamicUi.pages.selectedPage))

  const isVertical = pageData[selectedPage]?.is_vertical

  const isAllFieldsValid = (isVertical ? selectedTab?.image_url?.trim() : selectedTab?.title?.trim()) && selectedTab?.obj?.id && selectedTab?.type;



  const onSubmit = ()=>{
    if(isAllFieldsValid && !isLoading){

      const data = {
        title: selectedTab.title?.trim() ?? "",
        type: selectedTab.type,
        value: selectedTab.obj.id?.toString(),
        image_url: selectedTab.image_url,
        ...(selectedTab.is_quickee !== undefined && {is_quickee: selectedTab.is_quickee})
      };

      dispatch(tryAddOrUpdatePageTab({id: selectedTab.id, data }));
    }

  }



  return (
    <CustomButton children={selectedTab?.id ? "Update" : "Add"} onClick={onSubmit} disabled={!isAllFieldsValid || isLoading}/>

  );
};

export default PageTabSubmitButton;
